import * as React from 'react';
import { useEffect, useRef } from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link, { LinkProps } from '@mui/material/Link';
import AddIcon from '@mui/icons-material/Add';


import { styled, alpha } from '@mui/material/styles';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';


import {
    Link as RouterLink,
    useLocation,
    useNavigate,
    useParams,
} from 'react-router-dom';

import { isEmpty, keys } from 'lodash';

import { useAppSelector } from '../../store/hooks';
import { Button, Divider } from '@mui/material';

import { VocuherCategory, InvoiceRoute, Utils } from "../../utils/common-utils";

interface ILinkRouterProps extends LinkProps {
    to: string;
    replace?: boolean;
}

const breadcrumbNameMap: { [key: string]: string } = {
    '/account': 'My Businesses',
    '/account/create': 'Create',
    '/account/edit': 'Edit',
    '/users': 'Members',
    '/users/create': 'Create',
    '/users/user-details': 'Details',
    '/users/permissions': 'Permissions',
    '/account/account-info': 'My Business Information',
    '/account/account-details': 'My Business Information',
    '/users/edit': 'Edit',
    //static menu breadcrum
    //End of static menu breadcrum
    '/home': 'Dashboard',
    '/AR': 'AR',
    '/sales': 'Sales',
    '/purchase': 'Purchases',
    '/purchases': 'Purchases',
    '/purchase/scan-invoice': 'Scan Invoice',
    '/scan-invoice': 'Scan Invoice',
    '/sales/non-gst-invoice': 'Non GST Invoice',
    '/sales/non-gst-invoice/create': 'Create',
    '/sales/estimate': 'Estimate',
    '/sales/estimate/create': '',
    '/sales/estimate/edit': 'Edit',
    '/sales/credit-note': 'Credit Note',
    '/sales/credit-note/create': '',
    '/sales/credit-note/edit': 'Edit',
    '/sales/debit-note': 'Debit Note',
    '/sales/debit-note/create': '',
    '/sales/debit-note/edit': 'Edit',
    '/sales/invoice': 'Invoice',
    '/sales/invoice/create': 'Create',
    '/sales/invoice/edit': 'Edit',
    '/invoice': 'Invoice',
    '/invoice/view': 'Preview',
    '/invoice/preview': 'Preview',
    '/invoice-payment-receipt': 'Payment Receipt',
    '/invoice-payment-receipt/view': 'Payment Receipt Preview',
    '/AP': 'AP',
    '/account-receivable': 'Invoices',
    '/account-payable': 'Purchase',
    '/account-payable/invoice': 'Invoice',
    '/account-payable/invoice/create': 'Create',
    '/account-payable/invoice/edit': 'Edit',
    '/cashflow': 'Cashflow',
    '/buyers': 'Buyers',
    '/customers': 'Buyers',
    '/customer': 'Buyers',
    '/customer/create': 'New Buyer',
    '/suppliers': 'Suppliers',
    '/inventory': 'Inventory',
    '/inventory/stock': 'Stock',
    '/inventory/stock/in-hand-report': 'Stock In-Hand Report',
    '/inventory/stock/out-report': 'Stock Out Report',
    '/inventory/locations': 'Locations',
    '/inventory/grn': 'Goods Receipt',
    '/inventory/grn/report': 'Goods Receipt Report',
    '/inventory/grn/new': 'New Goods Receipt',
    '/inventory/batches': 'Batches',
    '/inventory/requisitions': 'Requisitions',
    '/inventory/requisitions/report': 'Requisitions Report',
    '/inventory/requisitions/new': 'New Requisition',
    '/inventory/transfers': 'Transfers',
    '/inventory/transfers/report': 'Transfers Report',
    '/inventory/transfers/new': 'New Transfer',
    '/inventory/recipes': 'Recipes',
    '/inventory/recipes/new': 'New Recipe',
    '/inventory/open-containers': 'Open Containers',
    '/inventory/variants': 'Variants',
    '/inventory/guide': 'Guide',
    '/inventory/purge': 'Data Purge',
    '/inventory/view': '',
    '/inventory/create': 'Create Item',
    '/inventory/edit': 'Edit Item',
    '/reports': 'Reports Dashboard',
    '/report': 'Reports Dashboard',
    '/expenses': 'Expense Management',
    // GST Reports
    '/reports/gstr-1-sales': 'GSTR-1 (Sales)',
    '/reports/gstr-2-purchase': 'GSTR-2 (Purchase)',
    '/reports/tds-payable': 'TDS Payable',
    '/reports/tds-receivables': 'TDS Receivable',
    '/reports/tcs-payable': 'TCS Payable',
    '/reports/tcs-receivables': 'TCS Receivable',
    // Transaction Reports
    '/reports/day-book': 'Day Book',
    '/reports/journal-entries-party-ledger': 'Party-Wise Ledger',
    '/reports/profit-loss': 'Profit And Loss Report',
    '/reports/balance-sheet': 'Balance Sheet',
    '/reports/balance-sheet-party-wise': 'Balance Sheet (Party Wise)',
    '/reports/cash-and-bank-report-all-payments': 'Cash & Bank Payments',
    '/reports/expense-category-report': 'Expense Category Report',
    '/reports/journal-entries-party': 'Expense Journal Entries',
    '/reports/cost-centre-report': 'Cost Centre Report',
    '/reports/migrate-journal-entries': 'Migrate Journal Entries',
    // Inventory Reports
    '/reports/low-stock-summary': 'Low Stock Summary',
    '/reports/stock-expiry-report': 'Stock Expiry Report',
    '/reports/rate-list': 'Rate List',
    '/reports/custom-item-report': 'Custom Item Report',
    '/reports/item-report-by-party': 'Item Report By Party',
    '/reports/item-purchase-summary': 'Item Purchase Summary',
    '/reports/item-sales-and-purchase-summary': 'Item Sales & Purchase Summary',
    // Party Reports
    '/reports/party-ledger': 'Party Statement (Ledger)',
    '/reports/party-ledger-dn': 'Party Ledger',
    '/reports/party-ledger-journal': 'Party Ledger (Journal Entries)',
    '/reports/party-wise-outstanding': 'Party Wise Outstanding',
    '/reports/party-balances': 'Party Balances',
    '/reports/employee-ledger': 'Employee Ledger',
    '/account-management': 'Account Management',
    '/my-profile': 'My Profile',
    '/how-to-use-wareozo': 'How To Use Wareozo',
    '/live-chat-support': 'Live Chat Support',
    '/settings': 'Settings',
    '/payments': 'Payments',
    '/payments/receipt-application': 'Receipt Application',
    '/people': 'People',
    '/people/employee': 'Employee',
    '/people/employee/create': 'New Employee',
    '/people/employee/edit': 'Edit Employee',
    '/people/employee/view': 'Employee Details',
    '/people/employee-config': 'People Config',
    '/people/salary': 'Salary',
    '/people/salary/list': 'Salary Management',
    '/people/salary/view': 'Salary Slip',
    '/people/payroll-settings': 'Payroll',
    '/people/payroll-settings/salary-config': 'Salary Config',
    '/people/payroll-settings/salary-config/new': 'New',
    '/coa': 'COA',
    '/coa/group-categories': 'Group Categories',
    '/coa/primary-groups': 'Primary Groups',
    '/coa/sub-groups': 'Sub Groups',
    '/coa/ledgers': 'Ledgers',
    '/coa/tax-settlement': 'Tax Settlement',
    '/coa/expense-settlement': 'Expense Settlement',
    '/coa/statutory-compliance': 'Statutory Compliance',
    '/coa/cost-centres': 'Cost Centres',
    '/charts-of-account': 'COA',
    '/charts-of-account/group-categories': 'Group Categories',
    '/charts-of-account/primary-groups': 'Primary Groups',
    '/charts-of-account/sub-groups': 'Sub Groups',
    '/charts-of-account/ledgers': 'Ledgers',
    '/charts-of-account/tax-settlement': 'Tax Settlement',
    '/charts-of-account/expense-settlement': 'Expense Settlement',
    '/charts-of-account/statutory-compliance': 'Statutory Compliance',
    '/charts-of-account/cost-centres': 'Cost Centres',
    '/taxes': 'Tax Settlement',
    '/cost-centres': 'Cost Centres',
    '/inventory-dashboard': 'Inventory Dashboard',
    '/coa-dashboard': 'CoA Dashboard',
};


// Crumbs whose own path is not a real route — point them at the nearest page instead
// so every clickable crumb actually lands somewhere.
const breadcrumbLinkMap: { [key: string]: string } = {
    '/report': '/reports',
    '/people/salary': '/people/salary/list',
    '/purchase': '/purchases',
    '/customer': '/buyers',
    '/customers': '/buyers',
    '/charts-of-account': '/coa',
    '/people/payroll-settings/salary-config': '/people/payroll-settings?tab=employeeSalaryConfig',
};

const LinkRouter = (props: ILinkRouterProps) => (
    <Link {...props} component={RouterLink as any} />
);

/**
 * Breadcrumbs component to show page header.
 */
const CustomBreadcrumbs = () => {
    const params = useParams();

    const location = useLocation();
    const navigate = useNavigate();
    // const { state } = location;
    const pathNames = location.pathname.split('/').filter((pathName) => pathName);
    // ID segments render nothing, so the current page is the last NON-id segment.
    // Everything before it stays a link — that's what makes the trail navigable.
    const isId = (value: string) => /^[a-f0-9]{24}$/i.test(value);
    let currentIndex = pathNames.length - 1;
    while (currentIndex > 0 && isId(pathNames[currentIndex])) currentIndex -= 1;
    // Voucher form: /(sales|purchase)/invoice/:vType/(create|edit/:id) -> "Sales / Credit Note / Create".
    const isVoucherForm = pathNames[1] === 'invoice' && ['create', 'edit'].includes(pathNames[3]);
    // Preview pages (/invoice/:id/preview?type=purchase) have no list of their own — the parent is Sales or Purchases.
    const isVoucherPreview = ['invoice', 'invoice-payment-receipt'].includes(pathNames[0]);
    // Invoice links carry type=sales|purchase, receipt links type=AR|AP.
    const isPurchasePreview = ['purchase', 'purchases', 'AP'].includes(new URLSearchParams(location.search).get('type') || '');
    // Voucher type of the previewed document, kept per id because the listing fetch clears invoiceDetails.
    const invoiceDetails: any = useAppSelector(state => state.invoices.invoiceDetails);
    const voucherById = useRef<{ [id: string]: { voucherType: string, pdfTemplate: string } }>({});
    if (invoiceDetails && invoiceDetails._id && invoiceDetails.voucherType) {
        voucherById.current[invoiceDetails._id] = { voucherType: invoiceDetails.voucherType, pdfTemplate: invoiceDetails.pdfTemplate || '' };
    }
    const previewVoucher = voucherById.current[pathNames[1]];
    const previewVoucherType = previewVoucher ? previewVoucher.voucherType : '';
    const voucherCrumb = (index: number): { name?: string, to?: string } => {
        if (isVoucherPreview && index === 0) return isPurchasePreview ? { name: 'Purchases', to: '/purchases' } : { name: 'Sales', to: '/sales' };
        // "Invoice Preview", "Credit Note Preview", "Purchase Invoice Preview"…
        if (pathNames[0] === 'invoice' && pathNames[index] === 'preview' && previewVoucherType) return { name: `${previewVoucherType} Preview` };
        if (!isVoucherForm) return {};
        if (index === 2) return { name: Utils.getInvoiceRouteName(pathNames[2]).pageTitle, to: pathNames[0] === 'purchase' || pathNames[0] === 'purchases' ? '/purchases' : '/sales' };
        if (index === 3) return { name: pathNames[3] === 'create' ? 'Create' : 'Edit' };
        return {};
    };
    const { accounts, selectedAccountId } = useAppSelector(state => state.account);
    const { users } = useAppSelector(state => state.users);
    const { inventoryDeatils } = useAppSelector(state => state.inventories);

    // const [name, setName] = useState('');
    let lastParam = '';

    // Handle estimate button
    const handleNewTransaction = (vCategory: string, vType: string) => {
        let redirectTo = '';
        const invoiceMeta = Utils.getInvoiceRouteName(vType);
        if (vCategory && vType) {
            redirectTo = `/${vCategory}/invoice/${invoiceMeta.routeName}/create`;
        }
        // if (path == 'invoice') {
        //     redirectTo = `/sales/${path}/create`;
        // }
        // else if (path == 'estimate') {
        //     redirectTo = `/sales/${path}/create`;
        // } else {
        //     redirectTo = `/sales/${path}/create`;
        // }


        navigate(redirectTo);
    };

    /**
     * Set name of the selected account/user.
     */
    useEffect(() => {
        if (!isEmpty(params)) {
            const paramNames = keys(params);

            switch (paramNames[0]) {
                case 'accountId':
                    //const account = accounts.find(account => account._id === params.accountId);

                    //setName(account?.name || '');
                    break;
                case 'userId':
                    const user = users.find(user => user._id === params.userId);

                    if (user && user._id) {
                        breadcrumbNameMap['/users/user-details/' + user._id] = user.name;
                    }

                    //setName(user?.name || '');
                    break;
                case 'inventoryId':
                    if (inventoryDeatils && inventoryDeatils._id) {
                        breadcrumbNameMap['/inventory/view/' + inventoryDeatils._id] = inventoryDeatils.name;
                    }
                    break;
                default:
                    break;
            }
        }

    }, [params, accounts, users, inventoryDeatils])

    return (
        <div>
            {/* Adding `Home` as default to every BreadCrumb path */}
            <Breadcrumbs aria-label="breadcrumb" sx={{ mt: -1.5, ml: 3 }}>
                <LinkRouter
                    underline="hover"
                    color="inherit"
                    fontWeight="bold"
                    to={'/home'}
                    key={'home'}
                >
                    Home
                </LinkRouter>
                {pathNames.map((value, index) => {
                    // Skip rendering if it's an ID parameter (24 character hex string)
                    const isIdParam = /^[a-f0-9]{24}$/i.test(value);

                    // Special case: if this is an ID and it's the last element, show the item name
                    if (isIdParam) {
                        // Receipt preview: the id crumb links back to the invoice the receipt belongs to.
                        if (pathNames[0] === 'invoice-payment-receipt' && index === 1 && previewVoucher) {
                            return (
                                <LinkRouter
                                    underline="hover"
                                    color="inherit"
                                    fontWeight="bold"
                                    to={`/invoice/${value}/preview?templateId=${previewVoucher.pdfTemplate}&type=${isPurchasePreview ? VocuherCategory.PURCHASE : VocuherCategory.SALE}`}
                                    key={value}
                                >
                                    {`${previewVoucher.voucherType} Preview`}
                                </LinkRouter>
                            );
                        }
                        if (index === pathNames.length - 1) {
                            // Check if we're on an inventory view page
                            if (pathNames.includes('inventory') && pathNames.includes('view') && inventoryDeatils && inventoryDeatils.name) {
                                // Truncate to first 5 words
                                const words = inventoryDeatils.name.split(' ');
                                const displayName = words.length > 5
                                    ? words.slice(0, 5).join(' ') + '...'
                                    : inventoryDeatils.name;

                                return (
                                    <Typography
                                        key={value}
                                        color="text.primary"
                                        fontWeight="bold"
                                    >
                                        {displayName}
                                    </Typography>
                                );
                            }
                        }
                        return null;
                    }

                    // Skip "view" segment when it's part of inventory/view/[id] pattern
                    if (value === 'view' && pathNames.includes('inventory') && index < pathNames.length - 1) {
                        const nextIsId = /^[a-f0-9]{24}$/i.test(pathNames[index + 1]);
                        if (nextIsId) {
                            return null;
                        }
                    }

                    // The bare "invoice" segment of a voucher form has no page of its own.
                    if (isVoucherForm && index === 1) {
                        return null;
                    }

                    // if path name is accountID we don't need breadcrumb for the same
                    if (selectedAccountId !== pathNames[index]) {
                        const to = `/${pathNames.slice(0, index + 1).join('/')}`;

                        // Special handling for /invoice/[id]/view pattern
                        const cleanedPath = to.replace(/\/[a-f0-9]{24}/gi, '');

                        const getCrumbName = () => {
                            if (voucherCrumb(index).name) return voucherCrumb(index).name;
                            // When on a sub-route under Reports (e.g. /reports/day-book), show parent crumb as "Reports"
                            if (index < currentIndex && (to === '/reports' || cleanedPath === '/reports' || to === '/report' || cleanedPath === '/report')) {
                                return 'Reports';
                            }
                            return breadcrumbNameMap[cleanedPath] || breadcrumbNameMap[to] || Utils.capitalizeFirstLetter(pathNames[index].replace(/-/g, ' '));
                        };

                        // Every crumb before the current page is a link
                        if (index < currentIndex) {
                            lastParam = to;
                            return (
                                <LinkRouter
                                    underline="hover"
                                    color="inherit"
                                    fontWeight="bold"
                                    to={voucherCrumb(index).to || breadcrumbLinkMap[cleanedPath] || to}
                                    key={to}

                                >
                                    {getCrumbName()}
                                </LinkRouter>
                            );
                        } else {
                            lastParam = to;
                            // As this is the last param in the path we are just showing bold without underline.
                            return (
                                <Typography
                                    key={to}
                                    color="text.primary"
                                    fontWeight="bold"

                                >
                                    {getCrumbName()}
                                </Typography>
                            );
                        }
                    } else
                        return null
                })}
            </Breadcrumbs>

            {/* <Typography sx={{ marginTop: 'px' }} gutterBottom variant="h3" component="div">
                {breadcrumbNameMap[lastParam]}
            </Typography> */}
            {/* <div style={{ display: "flex", flexDirection: 'row', justifyContent: 'flex-end', clear: "both", marginRight: '10px', marginTop: '-20px'}}>

            <div> */}
            {/* <Button
                // onClick={(e) => handleEditEstimateClick(row)}
                    startIcon={<AddIcon />}
                    variant="contained"
                    color='secondary'
                    // onClick={handleAddCreditNote}
                    style={{ fontSize: '14px', width: '200px', height: '35px', marginLeft: '15px', alignSelf: 'right' }}
                >
                    New Credit Note
                </Button> */}
            {/* </div> */}
        </div>
    );
}

export default CustomBreadcrumbs;
